export var DEFAULT_HAMS_RECAPTCHA_BASE_URL = '/hamlet/1.0/public/reCaptcha/siteKey';